<template>

<div class="card card--large" v-cloak v-show="!isPartnerUser">

  <div class="card__title">
    <h2>{{ $_('crm_client_search') }}</h2>
  </div>

  <form class="push--top" v-on:submit.prevent="onSubmit('searchForm')" data-vv-scope="searchForm">
    <div class="form grid">
      <div class="grid__item one-third portable--one-whole">
        <div class="form__line push-half--bottom">
          <div class="form__field">
            <label for="search">{{ $_('company_name') }}:</label>
            <input type="text" v-validate="'required'" name="search" id="search" v-model="search" class="field field--text" :class="{ 'parsley-error': errors.has('searchForm.search') }">
            <span v-show="errors.has('searchForm.search')" class="parsley-errors-list ">{{ errors.first('searchForm.search') }}</span>
          </div>
        </div>
        <div class="form__line flush--bottom">
          <button type="submit" class="button button--small button--primary" :disabled="loading">{{ $_('search') }} <i class="fa fa-spin fa-spinner" v-if="loading"></i></button>
          <button type="button" class="button button--small" v-if="isAdmin" @click="global.showNewClientDetails = !global.showNewClientDetails">{{ $_('enter_manually') }}</button>
        </div>
      </div><!--
      --><div class="grid__item one-third portable--one-whole" v-if="clients.length">
        <div class="form__line">
          <div class="form__field">
            <label for="client">{{ $_('select_client') }}:</label>
            <select name="client" id="client" v-model.number="client" class="field field--select" @change="clientSelect()">
              <!-- <option v-bind:value="null" selected>None</option> -->
              <option v-for="(c, index) in clients" v-bind:key="index + '-' + c.id" v-bind:value="c">{{ c.contactname }} ({{ c.companyname }}) - {{ c.id }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="form__line flush--bottom push-half--top" v-if="error">
      <div class="form__field">
        <div class="parsley-error">{{ error }}</div>
      </div>
    </div>
  </form>
</div>

</template>

<script>
import CRM from './CRM';
import GlobalStore from './Global.store';

export default {
  mixins: [CRM],
  props: {
    showNewClientDetails: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      clients: [],
      client: null,
      loading: false,
      search: '',
      error: null,
      global: GlobalStore,
    }
  },
  mounted() {
    if (this.showNewClientDetails !== undefined) {
      this.global.showNewClientDetails = this.showNewClientDetails;
    }
    if (this.isPartnerUser) {
      this.global.showNewClientDetails = true;
    }
  },
  computed: {
    isAdmin () {
      return this.global.insightUser && this.global.insightUser.admin === 1;
    },
    isPartnerUser () {
      return this.global.insightUser && this.global.insightUser.admin === 4;
    }
  },
  methods: {
    clientSelect() {
      let self = this;
      this.CRM_getClient(this.client.id).then((response) => {
        if (response && response.data && response.data.length && response.data[0].rep.length) {
          self.client.rep = `${response.data[0].rep[0].fname} ${response.data[0].rep[0].lname}`;
        }
        self.fillData();
        self.global.showNewClientDetails = true;
      }).catch((error) => {
        console.error(error);
      });
    },
    fillData() {
      const data = this.formatData()
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const element = data[key];
          $('.js-client-create #' + key).val(element);
        }
      }
    },
    formatData() {
      let package_id = 0;
      if (this.client) {
        if (this.client.Division === 'CGPM') {
          package_id = 3;
        } else if (this.client.Division === 'DRMG') {
          package_id = 1;
        }
      }
      return {
        company_name: (this.client) ? this.client.companyname || '' : '',
        crm_client_id: (this.client) ? this.client.id || '' : '',
        phone1: (this.client) ? this.client.phone1 || '' : '',
        phone2: (this.client) ? this.client.phone2 || '' : '',
        email1: (this.client) ? this.client.email || '' : '',
        email2: (this.client) ? this.client.email2 || '' : '',
        postal: (this.client) ? this.client.postalcode || '' : '',
        province: (this.client) ? this.client.province || '' : '',
        address_1: (this.client) ? this.client.address || '' : '',
        city: (this.client) ? this.client.city || '' : '',
        country: (this.client) ? 'CA' : '',
        sales_rep: (this.client) ? this.client.rep || '' : '',
        package_id: package_id,
      }
    },
    onSubmit: function(scope) {
      var self = this;
      self.error = null;
      self.$validator.validateAll(scope).then(function(result) {
        if (!result) {
          return false;
        }
        self.loading = true;
        self.CRM_clientSearch(self.search).then(
          function(response) {
            self.clients = response.data;
            if (self.clients.length === 0) {
              self.error = self.$_('no_clients_found');
            }
            self.loading = false;
          },
          function(error) {
            console.error(error);
            self.loading = false;
          }
        );
      });
    },
  }
}

</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/CrmClientSearch.vue